/*
 * サブシステム名：マスタ管理
 * 機能名：品名一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdTextBox from '../../components/DdTextBox.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

export default {
  name: 'MstHinmeiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      hinmeiCd: '',
      hinmeiNm: '',
      torihikisakiCd: ''
    },
    page: 1,
    /*
    headersTorihikisakiList: [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ],
    */
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        if (elem.tanka === null || elem.tanka === undefined) {
          elem.tankaDisp = ''
        } else {
          elem.tankaDisp = filter.numericFormatter(elem.tanka)
        }
        elem.hinJuuryoDisp = elem.hinJuuryo ? filter.numericFormatter(elem.hinJuuryo) : ''
        elem.hinLotDisp = elem.hinLot ? filter.numericFormatter(elem.hinLot) : ''
        elem.hinIrisuDisp = elem.hinIrisu ? filter.numericFormatter(elem.hinIrisu) : ''
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    filteredTorihikisakiList () {
      // 得意先を出力
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstHinmeiList.defineHeaderPromise')
            self.headers = [
              { text: '品名コード', value: 'hinmeiCd' },
              { text: '品名', value: 'hinmeiNm' },
              { text: '品名カナ', value: 'hinmeiNmKana' },
              { text: '得意先名称', value: 'torihikisakiNm' },
              { text: '単価', value: 'tankaDisp', align: 'end' },
              { text: '単位種別', value: 'unitKbnNm' },
              { text: '重量', value: 'hinJuuryoDisp', align: 'end' },
              { text: 'ロット', value: 'hinLotDisp', align: 'end' },
              { text: '入数', value: 'hinIrisuDisp', align: 'end' },
              { text: '荷姿', value: 'hinNisugata' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              hinmeiCd: '',
              hinmeiNm: '',
              torihikisakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstHinmeiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstHinmeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstHinmeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstHinmeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstHinmeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this

      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstHinmei/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
                itpSuryoJuryoKbn: self.conditions.itpSuryoJuryoKbn
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    /*
    onSearchButtonClick: function (e) {
      // 20210203 validateAllはmixin側で呼んでくれるので必要ない
      // const isValid = this.validateAll(this.$refs)
      // console.log('validate all ', isValid)
      // if (isValid) {
      console.log('serach clicked')
      this.Effects.loadStart()
      this.search().then(() => {
        console.log('this.search()', this.rows)
        this.Effects.loadComplete()
      })
      // }
    },
    // ★TODO★
    // 現状、完全一致検索で実装しているが、部分一致等に見直しが必要になる予定。(API側) (※課題No.100)
    search: function () {
      return new Promise(resolve => {
        this.HttpClient
          .post('/api/v1/vwCMstHinmei/search', this.conditions)
          .then((data) => {
            this._setMessages(data).then(() => {
              if (!data.isValid) {
                self.Effects.loadComplete()
                return
              }
              this.rows = data.payload
              const cache = {
                rows: this.rows,
                conditions: this.conditions,
                searchText: this.searchText
              }
              this.saveToChache(cache)
                .then(() => {
                  resolve()
                })
            })
          })
      })
    },
    */
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              hinmeiCd: '',
              hinmeiNm: '',
              torihikisakiCd: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCMstHinmei/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
